var Lib = /** @class */ (function () {
    function Lib(el) {
        if (typeof el === 'string') {
            this.el = document.querySelector(el);
        }
        else {
            this.el = el;
        }
    }
    Lib.prototype.onMounted = function () { };
    Lib.prototype.onUpdated = function () { };
    return Lib;
}());
export default Lib;
